// @ts-nocheck

import React, { forwardRef, useContext } from 'react';
import { Group, Image, Rect } from 'react-konva';

import { __ } from '../../../i18n/l10n';
import BetshareContext from '../contexts/BetshareContext';
import { getRelativeValue } from '../utils';

import ScalableText from './ScalableText';

const Footer = forwardRef(function Footer(props, ref) {
  const { y, x } = props;
  const {
    images: { logoWina, footerGradient },
    stageWidth,
  } = useContext(BetshareContext);

  return (
    <Group x={x} y={y} ref={ref}>
      <Rect
        x={0}
        y={0}
        width={stageWidth}
        height={getRelativeValue(43, stageWidth)}
        fillLinearGradientStartPoint={{ x: 0, y: 0 }}
        fillLinearGradientEndPoint={{ x: 0, y: getRelativeValue(60, stageWidth) }}
        fillLinearGradientColorStops={[0, '#363636', 1, '#0f0f0f']}
      />
      <ScalableText
        text={__('Winning is everything').toUpperCase()}
        x={getRelativeValue(72, stageWidth)}
        y={getRelativeValue(7, stageWidth)}
        width={getRelativeValue(264, stageWidth)}
        height={getRelativeValue(20, stageWidth)}
        fontSize={getRelativeValue(12, stageWidth)}
        fontFamily="BettingPoliticaExtraBoldItalic, sans-serif"
        fill="#fff"
        align="right"
        verticalAlign="middle"
      />
      <ScalableText
        text={__('!desc:BetshareWebsite').toUpperCase()}
        x={getRelativeValue(72, stageWidth)}
        y={getRelativeValue(24, stageWidth)}
        width={getRelativeValue(264, stageWidth)}
        height={getRelativeValue(12, stageWidth)}
        fontSize={getRelativeValue(9, stageWidth)}
        fontFamily="BettingPoliticaExtraBoldItalic, sans-serif"
        fill="#fff"
        align="right"
        verticalAlign="middle"
      />
      <Image
        image={footerGradient}
        x={getRelativeValue(84, stageWidth)}
        y={getRelativeValue(21, stageWidth)}
        width={getRelativeValue(202, stageWidth)}
        height={getRelativeValue(17, stageWidth)}
      />
      <Image
        image={logoWina}
        x={getRelativeValue(354, stageWidth)}
        y={getRelativeValue(4, stageWidth)}
        width={getRelativeValue(34, stageWidth)}
        height={getRelativeValue(34, stageWidth)}
      />
    </Group>
  );
});

export default Footer;
